module.exports = "/images/it.svg?423024ebf93307341c320986fbde0492";